import type { ManagedUser } from '../api'
import { PositionCombobox } from '../PositionCombobox'

type Props = {
	user: ManagedUser
	editFullName: string
	editPosition: string
	passwordValue: string
	passwordConfirmValue: string
	positionOptions: string[]
	profileSaving: boolean
	profilePasswordInvalid: boolean
	onEditFullName: (v: string) => void
	onEditPosition: (v: string) => void
	onPasswordValue: (v: string) => void
	onPasswordConfirmValue: (v: string) => void
	onBackdrop: () => void
	onCancel: () => void
	onSubmit: () => void
}

export function EditProfileModal({
	user,
	editFullName,
	editPosition,
	passwordValue,
	passwordConfirmValue,
	positionOptions,
	profileSaving,
	profilePasswordInvalid,
	onEditFullName,
	onEditPosition,
	onPasswordValue,
	onPasswordConfirmValue,
	onBackdrop,
	onCancel,
	onSubmit,
}: Props) {
	return (
		<div className="modal-backdrop modal-backdrop-nested" onClick={onBackdrop}>
			<div className="modal-card" onClick={(e) => e.stopPropagation()}>
				<h2>Редактировать данные: {user.login}</h2>
				<div className="field">
					<label htmlFor="edit-profile-full-name">Имя</label>
					<input
						id="edit-profile-full-name"
						autoComplete="name"
						value={editFullName}
						onChange={(e) => onEditFullName(e.target.value)}
						placeholder="Иван Иванов"
					/>
				</div>
				<div className="field">
					<PositionCombobox
						label="Должность"
						value={editPosition}
						onChange={onEditPosition}
						options={positionOptions}
						placeholder="Выберите из списка или введите новую"
					/>
				</div>
				<p className="modal-profile-password-hint">Смена пароля (необязательно)</p>
				<div className="field">
					<label htmlFor="edit-profile-password">Новый пароль</label>
					<input
						id="edit-profile-password"
						type="password"
						autoComplete="new-password"
						value={passwordValue}
						onChange={(e) => onPasswordValue(e.target.value)}
						placeholder="Оставьте пустым, если не меняете"
					/>
				</div>
				<div className="field">
					<label htmlFor="edit-profile-password-confirm">Повторите пароль</label>
					<input
						id="edit-profile-password-confirm"
						type="password"
						autoComplete="new-password"
						value={passwordConfirmValue}
						onChange={(e) => onPasswordConfirmValue(e.target.value)}
						placeholder="Повторите пароль"
					/>
				</div>
				{profilePasswordInvalid ? <div className="error">Заполните оба поля пароля одинаково</div> : null}
				<div className="modal-actions">
					<button type="button" className="secondary-btn" onClick={onCancel} disabled={profileSaving}>
						Отмена
					</button>
					<button
						type="button"
						className="primary-btn"
						onClick={() => void onSubmit()}
						disabled={profileSaving || profilePasswordInvalid}
					>
						{profileSaving ? 'Сохранение...' : 'Сохранить'}
					</button>
				</div>
			</div>
		</div>
	)
}
